export default {
  "IN": {
    "TS": "TG",
    "UK": "UT",
    "CG": "CT",
  },
}
// https://mychargebee.atlassian.net/wiki/spaces/CHECKOUT/pages/3230892398/ANALYSIS+-+CHKOUTENGG-9351